<template>
  <aside class="container">
    <b-row class="sidebar-header justify-content-center bloc-centered">
      <div class="col-6 offset-3 col-md-12 offset-md-0 user-section">
        <router-link :to="{name: 'home_profile_show'}" :title="$t('user.profile_show')">
          <div class="sidebar-header__company">
              <img v-if="company.logo"
                   :src="company.logo"
                   :alt="company.name"
                   :class="[ isMobileAndShown ? '' : 'col-12' ]"
              />

              <fa v-else fa-class="user" :solid="false" />
          </div>

          <div class="sidebar-header__user text-center">
            <p>{{ user }}</p>

            <p>{{ company.name }}</p>
          </div>
        </router-link>

        <hr class="mt-2 mb-3"/>

        <p class="sidebar-header__logout text-center" v-on:click="mylogout">
          {{ logoutText | lowercase }}
        </p>
      </div>

      <div class="col-3 p-0 sidebar-header__bg-menu text-right">
        <menu-button v-if="isMobileAndShown" id="btn-menu" />
      </div>
    </b-row>

    <div class="sidebar-toolbar" :class="getFlexboxClass('middle')">
      <rounded-button v-for="tool in toolbar"
                      :key="tool.button.id"
                      :route="tool.button.route"
                      :title="tool.button.title"
                      :fa-class="tool.button.faClass"
                      :notif="notifs[tool.type]"
                      class="sidebar-button"
      />
    </div>

    <div class="sidebar-nav">
      <ul class="col-12 p-0">
        <router-link v-for="section in sections"
                     :key="section.id"
                     :to="{ name: section.name }"
                     tag="li"
                     class="sidebar-nav__list"
        >
          <a>
            {{ trans(section.label) | uppercase }}
          </a>
        </router-link>
      </ul>
    </div>

    <b-row class="sidebar-contact justify-content-center">
      <div :class="[ isMobileAndShown ? 'col-6 col-md-12' : 'col-12' ]"
           class="sidebar-contact__logo"
      >
        <img src="@/assets/img/bba/logo.png" alt="bba_logo" />
      </div>

      <p class="bba-contact col-12" :class="getFlexboxClass('middle')">
        {{ contactBBA.name }}
      </p>

      <p class="bba-tel col-12" :class="getFlexboxClass('middle')">
        {{ contactBBA.phone }}
      </p>

      <p class="sidebar-sendMessage col-md-12">
        <rounded-button :route="sendMessageButton.route"
                        :title="sendMessageButton.title"
                        :fa-class="sendMessageButton.faClass"
                        class="sidebar-button"
        />

        <router-link :to="{ name: 'home_message_create' }" class="label">
          {{ $t('message.send') }}
        </router-link>
      </p>
    </b-row>
  </aside>
</template>

<script>
import CommonApi from '@/api/commonApi'
import SecurityAPI from '@/api/security'
import { flexbox } from '@/utils/style'
import { customButton } from '@/utils/buttons'
import formatter from '@/components/global/mixins/formatterMethods'
import fa from '@/components/global/icon/fontAwesome'
import roundedButton from '@/components/frontoffice/button/rounded'
import menuButton from '@/components/frontoffice/button/menu'

export default {
  components: {
    formatter,
    fa,
    roundedButton,
    menuButton
  },

  mixins: [formatter],

  data () {
    return {
      commonApi: new CommonApi(),
      sections: [
        { label: 'new_booking', name: 'home' },
        { label: 'my_bookings.title', name: 'bookings' },
        { label: 'traveller', name: 'travellers' },
        { label: 'event', name: 'events' },
        { label: 'group', name: 'group' },
        { label: 'seminar', name: 'seminar' },
        { label: 'news', name: 'news' }
      ],
      user: this.$store.getters['security/login'],
      company: this.$store.getters['security/company'],
      contactBBA: this.$store.getters['security/contactBBA'],
      isImpersonated: this.$store.getters['security/isImpersonated'],
      toolbar: [],
      sendMessageButton: null,
      notifs: {
        messages: 0,
        notifs: 0
      }
    }
  },

  created () {
    this.toolbar = [
      {
        button: customButton('show', 'home_profile', this.user.id, null, 'user', 'user.profile_show')
      },
      {
        button: customButton('list', 'home_notification', this.user.id, null, 'bell', 'notification.show.show'),
        type: 'notifs'
      },
      {
        button: customButton('list', 'home_message', this.user.id, null, 'comments', 'message.show.show'),
        type: 'messages'
      },
      {
        button: customButton('show', 'home_help', null, null, 'question', 'help.show.show')
      }
    ]
    this.sendMessageButton = customButton('create', 'home_message', null, null, 'comments')
    this.setNotifs()
  },

  methods: {
    trans (label) {
      return this.translate(label, true)
    },

    getFlexboxClass (position = 'middle') {
      return flexbox.position.justifyContent(position)
    },

    mylogout: function (event) {
      if (this.isImpersonated) {
        SecurityAPI.impersonate()
      } else {
        this.$store.dispatch('security/logout')
          .then(() => {
            this.$store.commit('research/reset')
            this.$store.commit('data/bookingCancellationReasons', null)
            this.$router.push({ path: '/login' })
          })
      }
    },

    setNotifs () {
      this.commonApi.getNbMessagesAndNbNotif().then(response => {
        this.notifs = response.data
      })
    }
  },

  computed: {
    isMobileAndShown () {
      return this.$store.state.mobileMenu.isShown
    },

    logoutText () {
      return this.isImpersonated
        ? this.$t('logout.cancelImpersonate')
        : this.$t('logout.verb')
    },

    messagesNotifs () {
      return this.$store.state.messages.unseen
    }
  },

  watch: {
    $route () {
      this.setNotifs()
    },

    messagesNotifs (nb) {
      this.notifs.messages = nb
    }
  },

  mounted: function () {
    this.$root.$on('changeCompanyLogo', (logo) => {
      this.company.logo = logo
      this.$store.commit('security/changeCompanyLogo', logo)
    })
  }
}
</script>
